import { BlockTypesKeys, BlockVerbTypesConfig_local } from './events/block'
import { IBaseObjectExtensions } from './events/common'
import { CourseTypesKeys, CourseVerbTypesConfig_local } from './events/course'
import { ElementVerbTypesConfig_local, ExcludedElements } from './events/elements'
import { SectionTypesKeys, SectionVerbTypesConfig_local } from './events/section'

export type ValidateKeysUtil<T, K extends keyof T> = {
  [P in K]: P extends keyof T ? T[P] : never
}

type VerbEntities = ElementVerbTypesConfig_local &
  CourseVerbTypesConfig_local &
  SectionVerbTypesConfig_local &
  BlockVerbTypesConfig_local

export type EntitiesVerbTypesConfig = ValidateKeysUtil<
  VerbEntities,
  ExcludedElements | CourseTypesKeys | SectionTypesKeys | BlockTypesKeys
>

export type ListAnalyticEntities = keyof VerbEntities

export type PickVerbsEntities<E extends ListAnalyticEntities> = keyof EntitiesVerbTypesConfig[E]

export type ElementVerbType<
  E extends ListAnalyticEntities,
  V extends PickVerbsEntities<E>,
> = EntitiesVerbTypesConfig[E][V]

interface IGenXAPIValidData<E extends ListAnalyticEntities, V extends PickVerbsEntities<E>> {
  elementType: E | undefined
  verb: V
  data: ElementVerbType<E, V>
}

export const genXAPIValidData = <E extends ListAnalyticEntities, V extends PickVerbsEntities<E>>({
  elementType,
  verb,
  data,
}: IGenXAPIValidData<E, V>) => {
  const xAPIData = { verb, elementType, ...data }
  return { xAPIData }
}

export type IExtensionsType = {
  [key: string]:
    | string
    | boolean
    | undefined
    | number
    | null
    | Record<string, unknown>
    | unknown
    | unknown[]
}

export interface ISendXapiStatement {
  verb: string
  elementId?: string
  elementUrl?: string
  elementType?: string
  objectExtensions?: IExtensionsType & IBaseObjectExtensions
  resultExtensions?: IExtensionsType
}
